import { render, staticRenderFns } from "./WaypointView.vue?vue&type=template&id=15b653ca"
import script from "./WaypointView.vue?vue&type=script&lang=js"
export * from "./WaypointView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports